'use client';
import React from 'react';
import { EmptyCart as Shared } from '@launchstore/shared-puck';
import { usePuckContext } from '@/components/puck/PuckContextProvider';

const SharedRender = (Shared as any).render;

/**
 * Storefront EmptyCart — passes `isEmpty` derived from the live cart.
 * In editor preview (no cart), defaults to true so the placeholder
 * "your cart is empty" is visible to the designer.
 */
function EmptyCartImpl(props: any) {
  const { context } = usePuckContext() as any;
  const cart = context?.cart;
  const itemCount = (cart?.items ?? []).length;
  const isEmpty = cart ? itemCount === 0 : true;
  return <SharedRender {...props} isEmpty={isEmpty} />;
}

export const EmptyCart: any = {
  ...Shared,
  render: (props: any) => <EmptyCartImpl {...props} />,
};
export default EmptyCart;
